import { PageBanner } from './common.types'

export interface NoticeOfInterestSuccessPageContent {
  backgroundImage?: string;
  title: string;
  description: string;
  information: string;
}

export interface NoticeOfInterestPageContent extends PageBanner {
  infoBannerInformation: string;
  formInformation: string;
  successPage: NoticeOfInterestSuccessPageContent;
}

export enum InterestType {
  GENERIC = 'Generic',
  UPSELL = 'Upsell',
  FWA = 'Fwa',
  FWA_LOWBAND = 'FwaLowband',
  FWA_SITE_DEVELOPMENT = 'FwaSiteDevelopment',
  RURAL = 'Rural',
  UPSELL_OPERATOR_CHANGE = 'UpsellOperatorChange',
  NO_CAPEX = 'NoCapex'
}

export interface NoticeOfInterestCommon {
  Email: string;
  FirstName: string;
  LastName: string;
  MobileNumber: string;
  PhoneNumber: string;
}

export interface NoticeOfInterestGenericRequest extends NoticeOfInterestCommon {
  Address: string;
  City: string;
  ZipPostalCode: string;
}

export interface NoticeOfInterestRequest extends NoticeOfInterestCommon {
  AddressId: number | null;
  CurrentOperator?: string;
  OperatorChangeDate?: string;
}
